import LtiTool from '@/models/LtiTool.js';
import Model from '@/models/Model.js';

export default class LtiToolDeployment extends Model {
    static entity = 'lti_tool_deployments';

    static fields() {
        return {
            id: this.attr(null),
            lti_tool_id: this.attr(null),

            ...super.fields(),

            tool: this.belongsTo(LtiTool, 'lti_tool_id'),
        };
    }
}
